require('./cardDetailsTravelPlus.scss');

// @core
const React = require('react');
const PropTypes = require('prop-types');

// @vendor
const moment = require('moment');
const { FormattedText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const CardsBoxHeaderTravelPlusToggle = require('components/cards/cardsBox/cardsBoxHeader/cardsBoxHeaderToggles/cardsBoxHeaderTravelPlusToggle');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { TRAVEL_PLUS_R42 } = require('constants/flagBasedFeatures');

//@constants
const {
    R42_CARD_ON,
    R42_CARD_PENDING_DEACTIVATION,
    R42_CARD_VIP,
} = require('constants/cardR42States');
const {
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
} = require('constants/index');

class CardDetailsTravelPlus extends React.Component {
    componentDidMount() {
        const {
            immCard,
            setCardTravelPlus,
        } = this.props;

        setCardTravelPlus(immCard.get('cardId'));
    }

    render() {
        const {
            hireTravelPlusCCWrapUpOffStart,
            hireTravelPlusCCWrapUpOnStart,
            immCard,
            immGlobalVariables,
            immSignaturePattern,
            immTravelPlus,
            setCardTravelPlus,
            setTravelPlus,
            travelPlusReset,
            flagBasedFeatures
        } = this.props;
        const titular = 'TITULAR'

        const immCardTravelPlus = immCard.get('travelPlus');
        const status = immCardTravelPlus.get('status');
        const travelSwitchVisible = immCard.getIn(['r42', 'travelSwitchVisible']);
        const vip = immCard.getIn(['r42', 'vip']);
        const descIntervenciones = immCard.get('interventionType') === titular;

        let validDate = immCardTravelPlus.get('validDate');
        let subscriptionDate = immCardTravelPlus.get('subscriptionDate');
        let message;
        let subscriptionDateText = '-';

        validDate = !!validDate ? moment(validDate).format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR) : '-';
        subscriptionDate = !!subscriptionDate ? moment(subscriptionDate).format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR) : '-';

        if (status === R42_CARD_VIP) {
            message = (
                <OKMessage type="informative">
                    <span>
                        <FormattedText value="cardDetailsTravelPlus-cardDetailsTravelPlus_VIPMessage1" />
                        <span className="card-details-travel-plus__bold">
                            <FormattedText value="cardDetailsTravelPlus-cardDetailsTravelPlus_VIPMessage2" />
                        </span>
                    </span>
                </OKMessage>
            );
        } else if (!immCardTravelPlus.get('error')) {
            if (status === R42_CARD_ON) {
                subscriptionDateText = subscriptionDate;
            } else if (status === R42_CARD_PENDING_DEACTIVATION) {
                message = (
                    <OKMessage type="informative">
                        <FormattedText
                            injectedStrings={[validDate]}
                            value="cardDetailsTravelPlus-cardDetailsTravelPlus_pendingDeactivationMessage"
                        />
                    </OKMessage>
                );
            }
        }

        return (
            <React.Fragment>
                <OKInformativeList
                    columns={2}
                    title="cardDetailsTravelPlus-cardDetailsTravelPlus_title"
                >
                    <OKInformativeListItem
                        title="cardDetailsTravelPlus-cardDetailsTravelPlus_state"
                    >
                        <CardsBoxHeaderTravelPlusToggle
                            hireTravelPlusCCWrapUpOffStart={hireTravelPlusCCWrapUpOffStart}
                            hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                            immCard={immCard}
                            immGlobalVariables={immGlobalVariables}
                            immSignaturePattern={immSignaturePattern}
                            immTravelPlus={immTravelPlus}
                            setCardTravelPlus={setCardTravelPlus}
                            setTravelPlus={setTravelPlus}
                            showSwitchAlone={true}
                            travelPlusReset={travelPlusReset}
                            travelSwitchVisible={travelSwitchVisible}
                            vip={vip}
                            descIntervenciones={descIntervenciones}

                            forceVipBehavior={!flagBasedFeatures.get(TRAVEL_PLUS_R42)}
                        />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        icon="icon-pregunta"
                        information="cardDetailsTravelPlus-cardDetailsTravelPlus_renovationDateExplanation"
                        title="cardDetailsTravelPlus-cardDetailsTravelPlus_renovationDate"
                    >
                        <span className="card-details-travel-plus__bold">
                            {subscriptionDateText}
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
                {message}
            </React.Fragment>
        );
    }
}

CardDetailsTravelPlus.propTypes = {
    hireTravelPlusCCWrapUpOffStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    setCardTravelPlus: PropTypes.func.isRequired,
    setTravelPlus: PropTypes.func.isRequired,
    travelPlusReset: PropTypes.func.isRequired,
};

module.exports = CardDetailsTravelPlus;
